import {Component, HostListener, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import 'rxjs/add/observable/of';
import {GetJsonService} from '../../shared/_services/get-json.service';
import {ValidationService} from '../../shared/_services/validation.service';
import {User} from '../../shared/_data-model/user';
import {LoginService} from '../../shared/_services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  user$: any;
  public signInForm: boolean = true;
  public resetPassword: boolean = false;
  public authenticationForm: boolean = false;
  public createNewPassword: boolean = false;
  public setNewPassword: boolean = false;
  public emailSentSuccess: boolean = false;
  public checkEmailStatus: boolean = false;
  public resetPasswordSuccess: boolean = false;
  user: any = FormGroup;
  resetEmail: any = FormGroup;
  setPasswordNew: any = FormGroup;
  createPassword: any = FormGroup;
  resetPasswordEmail: any = FormGroup;
  createPasswordNew: any = FormGroup;
  userId: any;
  token: any;
  error: any[];
  emailLinkError: any = "";
  errordetails: any;
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    public loginService: LoginService,
    private validationService: ValidationService,
    public getJsonService: GetJsonService,
    public router: Router

  ) {
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

    if (this.router.url.indexOf("/create-newpassword") > -1) {
      this.signInForm = false;
      this.createNewPassword = true;
      this.getQueryStringValue("val");
      this.userId = this.getQueryStringValue("val");
      this.token = this.getQueryStringValue("token");
      this.checkStatus();
    }
    if (user && user.userRoleId == 11) {
      this.router.navigate(['/hca-management']);
    } else if (user && user.userRoleId != 11) {
      this.router.navigate(['/hotel-management']);
    }
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.location.href = "/login";
  }

  /* Function to encode url fro create new password */
  getQueryStringValue (key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
  }
  checkStatus() {
    this.loginService.checkStatus(this.userId, this.token)
      .subscribe(
      res => {
        if (res.error === 0) {
          this.signInForm = false;
          this.createNewPassword = true;
        } else {
          this.signInForm = false;
          this.checkEmailStatus = true;
          this.emailLinkError = res.message;
        }
      },
      err => {
        console.error(err);
      });
  }

  /* Function to Authenticate user by providing valid Email and password */
  login(model) {
    this.loginService.login(model)
      .subscribe(
      res => {
        this.user$ = res.responseObj;
        if (res.error === 0) {
          this.errordetails = "";
          this.userId = this.user$.userId;
          this.loginService.profileInfo(this.user$.profilePicture);
          if (this.user$.isFirstLogin === true) {
            this.signInForm = false;
            this.setNewPassword = true;
          } else {
            let user = JSON.parse(localStorage.getItem('loggedInUser'));
            
            if(user && user.userRoleName === 'Concierge') {
              this.router.navigate(['/concierge']);
            } else if(user && user.userRoleName === 'Reception') {
              this.router.navigate(['/reception']);
            } else if (this.user$.userRoleId == 11) {
              this.router.navigate(['/hca-management']);
            } else if (this.user$ && this.user$.userRoleId == 1 || this.user$.userRoleId == 40) {
              this.router.navigate(['/members']);
            } else if (this.user$ && this.user$.userRoleId == 39 ) {
              this.router.navigate(['/employees/employee-list']);
            } else if (this.user$ && this.user$.userRoleId != 11) {
              this.router.navigate(['/hotel-management']);
            }

          }
          let redirectPath = localStorage.getItem('redirectAfterLogin');
          if(redirectPath){
            redirectPath = decodeURIComponent(redirectPath);
            const redirectDetails = redirectPath.split('||');
            if(redirectDetails && redirectDetails[0] == 'voucherTransactionPage') {
              this.router.navigate(['/members/modify/'+redirectDetails[1]+'/transaction-history']);
            } else {
              this.router.navigate(['/hotel-management']);
            }
          }
        }else if (res.error === 2){
          this.router.navigate(['/hca-loyalty-website-preview']);
        } else {
          this.errordetails = res.message;
        }
      },
      err => {
        console.error(err);
      });
  }

  sendEmail(email) {
    this.loginService.sendEmail(email.value.email)
      .subscribe(
      res => {
        if (res.error === 0) {
          console.log("email sent success");
          this.resetPassword = false;
          this.emailSentSuccess = true;
        } else {
          this.errordetails = res.message;
        }
      },
      err => {
        console.error(err);
      });
  }

  /* Function to send Email for creating new password */
  forgotPassword() {
    this.errordetails = "";
    this.signInForm = false;
    this.resetPassword = true;
  }

  /* Function to set a password for a user logging in for the first time */
  settingNewPassword(data) {
    this.loginService.setNewPassword(this.user$.userId, data)
      .subscribe(
      res => {
        if (res.error === 0) {
          console.log("set new password success");
          let user = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')) : null;
          if (user && user.userRoleId == 11) {
            this.router.navigate(['/hca-management']);
          } else if (user && user.userRoleId !== 11) {
            this.router.navigate(['/hotel-management']);
          } else {
            this.router.navigate(['/login']);
          }
        } else {
          this.errordetails = res.message;
        }
      },
      err => {
        console.error(err);
      });
  }

  /* Function to create a new password */
  creatingNewPassword(user) {
    this.loginService.createNewPassword(this.userId, user)
      .subscribe(
      res => {
        if (res.error == 1) {
          this.errordetails = res.message;
        } else {
          this.createNewPassword = false;
          this.resetPasswordSuccess = true;
        }
      },
      err => {
        console.error(err);
      });
  }

  /* Function to go back to login screen */
  backToLogin() {
    this.router.navigate(['/login']);
  }

  ngOnInit() {
    this.user = this.fb.group({
      isFirstLogin: [''],
      userId: [''],
      // username: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])],
    });

    this.resetEmail = this.fb.group({
      // email: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])]
      email: ['', Validators.compose([Validators.required])]
    });

    this.setPasswordNew = this.fb.group({
      password: ['', Validators.required],
      passwords: this.fb.group({
        password_new: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.password_regexPattern)])],
        password_confirm: ['', Validators.compose([Validators.required])]
      }, { validator: this.validationService.matchPassword })
    });

    this.createPassword = this.fb.group({
      password_new: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.password_regexPattern)])],
      password_confirm: ['', [Validators.required]]
    }, { validator: this.validationService.matchPassword });

    this.getJsonService.getJSON("../assets/messages_configuration/", "messages.json")
      .subscribe(
      (res) => {
        this.error = res.Error;
        console.log(res);
      },
      (err) => console.error("Get all error messages " + err));
  }

  onSubmit({ value, valid }: { value: User, valid: boolean }) {
    console.log("On Submit " + valid);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts